"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyPatient = void 0;
const BulletinBoard_1 = require("./BulletinBoard");
const MemoryBox_1 = require("./MemoryBox");
const FamilyMember_1 = require("./FamilyMember");
exports.EmptyPatient = {
    nucleusDataType: "patient",
    patientId: "",
    accountId: "",
    firstName: "",
    lastName: "",
    enableBiometrics: false,
    showCallButtonsBar: false,
    showCallButton: false,
    showCallButton2: false,
    showEmergencyButton: false,
    showFamilyCallButton: false,
    showWeather: false,
    localeTag: "EN",
    enableCallButtonSchedule: false,
    enableEmergencyButtonSchedule: false,
    useDefaultSchedule: false,
    enableMemoryBox: false,
    enableBlankMemoryBox: false,
    useHearingImpairedRingtone: false,
    videoCallsAllowed: true,
    callButtonText: "",
    callButtonText2: "",
    emergencyButtonText: "",
    familyCallButtonText: "",
    biometricsButtonText: "",
    addFamilyButtonText: "",
    memoryBoxButtonText: "",
    requestTimeoutMessageTextForPatient: "",
    offHoursMessage: "",
    bulletinBoard: BulletinBoard_1.EmptyBulletinBoard,
    memoryBoxMedia: MemoryBox_1.EmptyMemoryBox,
    family: FamilyMember_1.EmptyFamily,
    callButtonSchedule: [],
    patientApps: 0,
    upcomingPatientSchedule: null,
};
